import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q10 = ({ history }) => {
  const { t } = useTranslation();
  const Q10Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
      {
        id: 2,
        name: t('not_sure'),
        value: 'not_sure',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question10')}
      options={Q10Options}
      nextUrl="f1"
      screenName="q10"
    />
  );
};

export default Q10;
